export const resolveChildcareAccess = (appVersion: string, isAdminUser: boolean, known?: boolean) => {
  const childcareDeployed = appVersion === 'ALL';
  return {
    childcareEnabled: childcareDeployed && (isAdminUser || known === true),
    childcareResolved: !childcareDeployed || isAdminUser || typeof known === 'boolean',
  };
};

export default resolveChildcareAccess;
